import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReadFile } from '@paragon/client-tools';

type LoadingFilesState = readonly ReadFile[] | null;

const initialState: LoadingFilesState = null;

const loadingFilesSlice = createSlice({
  name: 'loadingFiles',
  initialState: initialState as LoadingFilesState,
  reducers: {
    setLoadingFiles: (state, action: PayloadAction<readonly ReadFile[] | null>) => action.payload,
  },
});

export const { setLoadingFiles } = loadingFilesSlice.actions;
export const loadingFiles = loadingFilesSlice.reducer;
